import React from "react";
import { Link } from "react-router-dom";
import l from "components/util/l";
import { Formik, Field, Form } from "formik";
import StyleColor from "components/util/helpers/StyleColor"


const VerifyEmailView = ({ verifyError, onClickGenerate, onClickVerifyAccount }) => (

  <main id="content" role="main" class="main pl-0">
    <StyleColor />
    <div class="container py-5 py-sm-7">
      <a class="d-flex justify-content-center mb-6" href={"/"}>
        <img class="z-index-2" src="/theme/svg/logos/logo-white.svg" alt="Logo" style={{ height: "2.65rem" }} />
      </a>

      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card card-lg mb-5 pt-1 px-1 pb-2 animate__animated animate__fadeInUp animate__faster">
            <div class="card-body">

              <div class="text-center">
                <div class="mb-5">
                  <h1 class="display-4">{l("Verificación de cuenta%VB042")}</h1>
                </div>
              </div>

              {verifyError ? (
                <>
                  <h3 class="mb-4 text-center">
                    {l("El link ya no es válido, han pasado mas de 20 minutos desde que se generó%VB026")}
                  </h3>

                  <button
                    class="btn btn-primary btn-block"
                    onClick={onClickGenerate}
                  >
                    {l("Generar nuevo link%VB043")}
                  </button>
                </>
              ) : (
                <>
                  <h3 className="mb-4">Termina de configurar tu cuenta</h3>
                  <Formik
                    initialValues={{}}
                    onSubmit={onClickVerifyAccount}
                  >
                    {() =>
                      <Form>

                        <div className="form-group row mb-3">
                          <div className="col-md-6">
                            <label for="formFirstName">Nombre(s) <span className='text-danger ml-1'>*</span></label>
                            <Field type="text" name="firstName" id="formFirstName"
                              class="form-control form-control-lg" tabindex="2"
                              placeholder={"Nombre(s)"} maxlength="512" required />
                          </div>
                          <div className="col-md-6">
                            <label for="formLastName">Apellidos <span className='text-danger ml-1'>*</span></label>
                            <Field type="text" name="lastName" id="formLastName"
                              class="form-control form-control-lg" tabindex="2"
                              placeholder={"Apellidos"} maxlength="512" required />
                          </div>
                        </div>

                        <div className="form-group mb-3">
                          <label for="formPassword">Contraseña <span className='text-danger ml-1'>*</span></label>
                          <Field type="password" name="password" id="formPassword"
                            class="form-control form-control-lg" tabindex="2" aria-describedby="passwordHelpBlock"
                            placeholder={"Contraseña"} maxlength="512" required />
                          <small id="passwordHelpBlock" class="form-text text-muted">
                            Usa, al menos, 8 caracteres con una mezcla de letras y números.
                          </small>
                        </div>

                        <div className="form-group mb-3">
                          <label for="formConfirmPassword">Confirmar contraseña <span className='text-danger ml-1'>*</span></label>
                          <Field type="password" name="confirmPassword" id="formConfirmPassword"
                            class="form-control form-control-lg" tabindex="2" aria-describedby="confirmPasswordHelpBlock"
                            placeholder={"Confirmar contraseña"} maxlength="512" required />
                          <small id="confirmPasswordHelpBlock" class="form-text text-muted">
                            Usa, al menos, 8 caracteres con una mezcla de letras y números.
                          </small>
                        </div>

                        <button type="submit" class="btn btn-lg btn-block btn-accent mb-2">
                          Establecer contraseña
                        </button>

                      </Form>
                    }
                  </Formik>
                </>
              )}

            </div>
          </div>
        </div>
      </div>

    </div>
  </main>
);

export default VerifyEmailView;